<template>
  <l-geo-json
    :visible="mapRegionsWithGeoData && $store.state.mode === 'overview'"
    :geojson="mapRegionsWithGeoData"
    :options="mapRegionsOptionsOverview"
    style="z-index: 402"
  ></l-geo-json>
</template>
<script lang="js">
import Vue from 'vue';
import {LGeoJson} from 'vue2-leaflet';
import {
  calculateStyle,
  onEachFeature,
  mouseOverRegion,
  mouseOutRegion,
  generateTooltip,
} from './methods'
import {navigateTo, resolve} from "@seamless/router";

export default Vue.extend({
  name: 'nmouc-map-overview',
  props: {
    mapRegionsWithGeoData: {
      type: Object,
      required: true,
    }
  },
  components: {
    LGeoJson,
  },
  data() {
    return {
      mapRegionsOptionsOverview: {
        style: {
          pane: 'mapRegionsPane'
        },
        onEachFeature: this.onEachFeature
      },
    };
  },
  methods: {
    onEachFeature,
    calculateStyle,
    mouseOverRegion,
    mouseOutRegion,
    generateTooltip,
    setSpecificRegionHovered(mapRegion, hovered) {
      if (mapRegion.selectedOTARegion) {
        this.$store.commit('setSpecificOtaRegionHovered', hovered);
      }
      if (mapRegion.upToDate) {
        this.$store.commit('setSpecificUpToDateRegionHovered', hovered);
      } else {
        this.$store.commit('setSpecificOutdatedRegionHovered', hovered);
      }
    },
    clickRegion(e) {
      let mapRegion = e.target.feature.properties.mapInfos;
      if (!mapRegion.upToDate && this.$store.getters.isDownloadManagerFeasible) {
        if (!mapRegion.selectedOTARegion) {
          this.$store.commit('toggleManualUpdateSelectedRegion', mapRegion)
        }
        const newUrl = resolve({namespace: 'mapupdate', path: "/manualupdate"});
        navigateTo(newUrl);
      }
    }
  },
});
</script>
